import { render, staticRenderFns } from "./doviz.vue?vue&type=template&id=6c5aff93"
import script from "./doviz.vue?vue&type=script&lang=js"
export * from "./doviz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports